import { __extends } from "tslib";
import { ASObject } from '@awayfl/avm2';
var FontPosture = /** @class */ (function (_super) {
    __extends(FontPosture, _super);
    function FontPosture() {
        return _super.call(this) || this;
    }
    FontPosture.forceNativeConstructor = true;
    FontPosture.forceNativeMethods = true;
    // JS -> AS Bindings
    FontPosture.NORMAL = 'normal';
    FontPosture.ITALIC = 'italic';
    return FontPosture;
}(ASObject));
export { FontPosture };
